/* Add CustomFields Sep 23, 2023 */
/*Add Account Rating Dec 30, 2023 */
/* Add kt-notes,d_savedRecord Feb 17, 2024 */
/* Add m_processVoice June 1, 2024 */
/* Add p_mode to custom-field, add officePhoneNo, mobilePhoneNo, otherPhoneNo Aug 8 , 2024 */
/* Add  readonly, required columns Jan 25, 2025 */
/* Add Bug fix for readonly, required columns Apr 26, 2025 */
/* Remove Notes May 30, 2025 */
/* GUI changes Phase1  May 15, 2026 */
<template lang="pug">
div
		rec-wrap(:p_mode="p_mode" :p_saveFn="m_saveFn" p_appEntKey="acct" :p_isModal="p_isModal" p_enableClone=true
		:p_requiredColumns="d_requiredColumns" :p_recData="d_recData" :p_rmndOpt="d_rmndOpt" :p_altView="d_altViewKey" @altViewChg="d_altViewKey = $event"   @focused="d_currentFocus = $event" @voice="m_processVoice")
			template(v-slot:rec-form-header)
				div(class="d-flex raisedHeader")
					div(style="text-align:left;width:20%" )
						kt-photo(id="accountPhoto" ref="kt-photo" p_prntRecKey="acct" :p_recInfo="c_recInfo" :p_photoRec="c_photoRec")
					div(class="d-flex flex-column justify-content-center")
						<span class="d-block"><span style="color:#4fa4ff; font-size:25px;">{{d_recData.accountName}}</span></span> 
						<sup><b-form-rating id="rating" style="border:none;"  variant="warning"  :value="d_recData.rating" size="sm" stars=5 inline readonly></b-form-rating></sup>
						<sup>Risk factor:<b v-html="c_ratingRF"></b></sup>
			template(v-slot:rec-form-left)
				span <span style="color:#ff9333;">*</span>indicates field is required.
				div(class="form-group")
					label(class="required-label") Account #
					b-form-input(class="styled-input" id="accountNo"  class="style-input" size="sm" v-model="d_recData.accountNo" disabled placeholder="Auto Generated")
				div(class="form-group")
					label(class="required-label") Account Name
					b-form-input(class="styled-input" id="accountName" size="sm"  v-model="d_recData.accountName" required)
				div(class="form-group")
					kt-address(id="address" :p_recData="d_recData" :p_readOnly="p_mode=='view'")
				div(class="form-group")
					label(:class="m_required('externalContacts')?'required-label':''") Account Contact(s)
					kt-list(
						p_appEntKey="extr"
						id="externalContacts"
						:p_currentVals="d_recData.externalContacts"
						:p_readOnly="p_mode=='view'||m_readOnly('externalContacts')"
						:p_enableCreate="true"
						:p_enableAdd="true"
						@change="d_recData.externalContacts = $event"
					)
			template(v-slot:rec-form-right)
				div(class="form-group")
					label(:class="m_required('accountTypeId')?'required-label':''") Account Type
					div
						b-form-select(class="styled-input" id="accountTypeId" class="styled-select" size="sm"  v-model="d_recData.accountTypeId" 
						:options="d_ref.selOpt(d_ref.accountTypes, d_recData.accountTypeId)"
						value-field="id" text-field="name" required)
				div(class="form-group" v-if="c_isOwner")
					label(:class="m_required('accountTypeId')?'required-label':''") Owner Type
					div
						b-form-select(class="styled-input" id="ownerTypeId" class="styled-select" size="sm"  v-model="d_recData.ownerTypeId" 
						:options="d_ref.selOpt(d_ref.ownerTypes, d_recData.ownerTypeId)"
						value-field="id" text-field="name")
				div(class="form-group")
					label(:class="m_required('phoneNo')?'required-label':''") Phone #
					kt-com-fld(id="phoneNo" :p_mode="p_mode"  typ="p" :p_readOnly="m_readOnly('phoneNo')" v-model="d_recData.phoneNo" placeholder="Direct")
					kt-com-fld(id="officePhoneNo" :p_mode="p_mode"  typ="f" :p_readOnly="m_readOnly('officePhoneNo')" v-model="d_recData.officePhoneNo" placeholder="Office")
					kt-com-fld(id="mobilePhoneNo" :p_mode="p_mode"  typ="pm" :p_readOnly="m_readOnly('mobilePhoneNo')" v-model="d_recData.mobilePhoneNo" placeholder="Mobile")
				div(class="form-group")
					label(:class="m_required('email')?'required-label':''") Email
					kt-com-fld(id="email" typ="@" :p_readOnly="m_readOnly('email')" v-model="d_recData.email")
				div(class="form-group")
					label(:class="m_required('website')?'required-label':''") Website
					kt-com-fld(id="website" typ="w" :p_readOnly="m_readOnly('website')"  v-model="d_recData.website")
				div(class="form-group")
					b-form-checkbox(id="inactive" class="styled-checkbox"  :value="true" v-model="d_recData.inactive") Inactive
				div(class="form-group")
					label(:class="m_required('accountOwnerId')?'required-label':''") Account Owner
					kt-select(id="accountOwnerId"
						p_appEntKey="team"
						p_class="styled-input"
						:p_currentVal="d_recData.accountOwner"
						:p_readOnly="p_mode=='view'||m_readOnly('accountOwnerId')"
						:p_enableCreate="true"
						@change="d_recData.accountOwner = $event; d_recData.accountOwnerId = ($event||{}).teamMemberId||null;"
					)
				div(class="form-group")
					label(:class="m_required('assignedTeamMembers')?'required-label':''") Assigned Team Member(s)
					kt-list(id="assignedTeamMembers"
						p_appEntKey="team"
						:p_currentVals="d_recData.assignedTeamMembers"
						:p_readOnly="p_mode=='view'||m_readOnly('assignedTeamMembers')"
						:p_enableCreate="true"
						:p_enableAdd="true"
						@change="d_recData.assignedTeamMembers = $event"
					)
			template(v-slot:rec-form-center)
				div(class="form-group")
					label(:class="m_required('accountDetails')?'required-label':''") Account Details
					b-input-group-prepend(class="px-0")
						b-input-group-text
							fa-icon(icon="list-ul")
						b-form-textarea(class="styled-input" id="accountDetails" size="sm"  v-model="d_recData.accountDetails" rows=5)
				kt-custom-field(v-if="d_customFields.length>0" :p_mode="p_mode" p_prntRecKey="acct" :p_recData="d_recData.customData"  @change="d_recData.customData=$event")
			template(v-slot:rec-alt-view)
				kt-tasks(v-if="d_altViewKey=='TASK'" ref="kt-tasks" p_prntRecKey="acct" :p_prntRecInfo="c_recInfo" p_enableCUFilter=true)
				kt-attach(v-else-if="d_altViewKey == 'AT'" ref="kt-attach" p_prntRecKey="acct" :p_recInfo="c_recInfo")
				kt-related(v-else-if="d_altViewKey=='RR'" :p_relatedGrids="m_relatedGrids()")
</template>

<script>
import { fn_getHashId } from "@/utils/util.js";
import { fn_saveRecord } from "@/utils/api.js";
import {ratingsRF, refData,userSettings } from "@/utils/ref-data.js";
import RecWrap from "@/components/RecWrap.vue";
import KTList from "@/components/Ctrl/KT-List.vue";
import KTAddress from "@/components/Ctrl/KT-Address.vue";
import KTTasks from "@/components/Ctrl/KT-Tasks.vue";
import KTAttach from "@/components/Ctrl/KT-Attach.vue";
import KTCustomField from "@/components/Ctrl/KT-CustomField.vue";
import KTRelated, {
  RelatedGridClass,
  getColFns,
} from "@/components/Ctrl/KT-Related.vue";

export default {
  name: "acct-rec",
  components: {
    "rec-wrap": RecWrap,
    "kt-list": KTList,
    "kt-address": KTAddress,
    "kt-tasks": KTTasks,
    "kt-attach": KTAttach,
    "kt-related": KTRelated,
	'kt-custom-field': KTCustomField,
  },
  created() {
    if (this.p_mode != "create" && !this.p_recNo) {
      this.d_recNo = fn_getHashId(this);
    } else if (this.p_recNo) {
      this.d_recNo = this.p_recNo;
    }
	var usrOpts = userSettings.userOptions;
	var readOnlyColumns=usrOpts['tableReadOnlyColumns'];
	var requiredColumns=usrOpts['tableRequiredColumns'];
	if(readOnlyColumns) this.d_readOnlyColumns=readOnlyColumns['kt-table-acct']||[];
	if(requiredColumns) this.d_requiredColumns=requiredColumns['kt-table-acct']||[];
	this.d_requiredFields=this.d_requiredColumns.map(c=>{return c.field;});

  },
  mounted() {
 		this.d_readOnlyColumns.forEach(col=>{if(document.getElementById(col)) document.getElementById(col).disabled=true;}); 
  },
  data() {
    return {
      d_ref: refData,
      d_recNo: null,
      d_recData: {},
      d_avgScore:null,
      d_rmndOpt: [], //Keep empty array here
      d_altViewKey: null,
      d_noClone: ["inactive"],
      d_win: window,
      d_customFields:refData.customFields.filter(c=>(c.context=='acct')),
      d_savedRecord:null,
	  d_currentFocus:null,
	  d_readOnlyColumns:[],
	  d_requiredColumns:[],
	  d_requiredFields:[],
    };
  },
  props: {
    p_recNo: String,
    p_mode: String,
    p_isModal: Boolean,
  },
  computed: {
	c_ratingRF(){var rating=this.d_recData.rating?this.d_recData.rating:0;
				var riskFactor=ratingsRF.filter(r=>r.rating==rating)[0];
				return riskFactor.html;
				},
    c_isOwner() {
      let acctType =
        refData.accountTypes.filter(
          (x) => x.id == this.d_recData.accountTypeId
        )[0] || {};
      return acctType.name == "Owner";
    },
    c_recInfo() {
      let rd = this.d_recData;
      return {
        Id: rd.accountId,
        No: rd.accountNo,
        Name: rd.accountName,
        Team: [rd.accountOwner, ...(rd.assignedTeamMembers || [])].filter(
          (x) => x != undefined
        ),
      };
    },
	c_photoRec() {
			let rd = this.d_recData;
			return {
				photoId: rd.photoId,
				photoURL: rd.photoURL,
				photoName: rd.photoName
			};
		},
  },
  methods: {
	m_processVoice(e){	
		document.getElementById(this.d_currentFocus).value=e;
	},
    m_saveFn() {
      //Called from  RecWrap, KTList, KTSelect
      let id = this.p_mode == "edit" ? this.d_recData.accountId : null;
      this.d_savedRecord=true;
      return fn_saveRecord("account", id, this.d_recData);
    },
    m_relatedGrids() {
      let fC = { key: "clnt", label: "Client", paramNm: "accountIdClnt" };
      let fD = { key: "dsgn", label: "Designer", paramNm: "accountIdDsgn" };

      let recId = this.d_recData.accountId;
      let recNm = this.d_recData.accountName;

      let rOppr = new RelatedGridClass(
        "acct",
        recId,
        recNm,
        "oppr",
        getColFns.oppr,
        [fC, fD]
      );
      let rproj = new RelatedGridClass(
        "acct",
        recId,
        recNm,
        "proj",
        getColFns.proj,
        [{ ...fC }, { ...fD }]
      ); //Need to cpoy

      return [rOppr, rproj];
    },
		m_readOnly(col){return (this.d_readOnlyColumns&&this.d_readOnlyColumns.includes(col))?true:false;},
		m_required(col){return (this.d_requiredFields&&this.d_requiredFields.includes(col))?true:false;},	
  },
  watch: {
    c_isOwner(nv) {
      if (!nv) this.d_recData.ownerTypeId = null;
    },
	p_mode(nv) {
			if(nv == 'create' || nv=='edit'){
				//- Read Only Columns.
				this.d_readOnlyColumns.forEach(col=>{if(document.getElementById(col)) document.getElementById(col).disabled=true;});
			}
		},
  },
};
</script>

<style>
.styled-input,
.styled-select {
  width: 100%;
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #ddd;  
}
.styled-input:disabled,
.styled-select:disabled {
  background-color: transparent;
  border-bottom: 1px solid #ddd;
}
.styled-input:focus,
.styled-select:focus {
  border-color: transparent;
  border-bottom: 1px solid #428bca;    
  box-shadow: none;
}
.raisedHeader{
	position1:fixed;
	width:1130px;
	padding: 10px;
	background-color: white;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
	border-radius: 8px;
	z-index1: 9;
	}
.raisedHeader img {
	border-radius: 8px;
}
.raisedHeader .accountName {
  align-items: center;
}
</style>
